<template>
    <div>
        <CModal
            size="xl"
            :centered="true"
            color="white"
            :show.sync="isShown"
            :closeOnBackdrop="false"
            >
            <template #header-wrapper>
                <div class="headers-modal">
                    <CRow>
                        <CCol sm="10">
                            <div>Setting Shift</div>
                        </CCol>
                        <CCol sm="2" class="text-right">
                            <img :src="closeIcon" @click="closePopUp()" style="cursor:pointer" width="20px" height="20px"/>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #body-wrapper>
                <div style="padding: 24px">
                    <CRow>
                        <CCol class="text-right" sm="12">
                            Last Update by {{ data.updatedBy }} at {{ data.updateDate }}
                        </CCol>
                    </CRow>
                    <CRow style="margin-top: 32px;">
                        <CCol sm="6">
                            <label>Apakah shift ada jam istirahat?</label>
                            <model-select :options="dataIsBreak"
                                class="form-control model-select"
                                v-model="isBreak"
                                placeholder="Pilih salah satu">
                            </model-select>
                        </CCol>
                        <CCol sm="6" v-if="isBreak.value == '1'">
                            <label>Apakah jam istirahat shift flexible?</label>
                            <model-select :options="dataIsFlexible"
                                class="form-control model-select"
                                v-model="isFlexible"
                                placeholder="Pilih salah satu">
                            </model-select>
                        </CCol>
                    </CRow>
                    <CRow style="margin-top: 46px;">
                        <CCol sm="12">
                            <CButton @click="closePopUp()" type="button" class="btn btn-cancel mr-2">Batal</CButton>
                            <CButton @click="saveSetting()" class="btn btn-edit-submit">
                                <span v-if="loading == false">Simpan</span>
                                <CSpinner v-else color="default" size="sm"/>
                            </CButton>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #footer-wrapper><span></span></template>
        </CModal>
    </div>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
export default {
    components: {
        ModelSelect
    },
    data() {
        return {
            loading: false,
            closeIcon: require('../../../assets/menu/icon_close.svg'),
            isShown: false,
            data: [],
            dataIsBreak: [],
            dataIsFlexible: [],
            isBreak: {
                value: '0',
                text: 'Tidak ada jam istirahat'
            },
            isFlexible: {
                text: 'Jam istirahat flexible',
                value: '1'
            },
        }
    },
    methods: {
        closePopUp() {
            this.data = []
            this.isShown = false
            this.isBreak = {
                value: '0',
                text: 'Tidak ada jam istirahat'
            },
            this.isFlexible = {
                text: 'Jam istirahat flexible',
                value: '1'
            },
            this.loading = false
        },
        saveSetting() {
            this.loading = true
            let payload = {
                isBreak: this.isBreak.value,
                isFlexible: this.isBreak.value == '1' ? this.isFlexible.value : null
            }
            this.$emit('saveSetting', payload)
        },
        getDataIsBreak() {
            this.dataIsBreak = [
                {
                    text: 'Ada jam istirahat',
                    value: '1'
                },
                {
                    text: 'Tidak ada jam istirahat',
                    value: '0'
                }
            ]
        },
        getDataIsFlexible() {
            this.dataIsFlexible = [
                {
                    text: 'Jam istirahat flexible',
                    value: '1'
                },
                {
                    text: 'Jam istirahat diatur pada jadwal',
                    value: '0'
                }
            ]
        },
        pharData() {
            this.isBreak = this.dataIsBreak.find(datas => datas.value == this.data.isBreak);
            this.isFlexible = this.dataIsFlexible.find(datas => datas.value == this.data.isFlexible);
        }
    },
    watch: {
        data() {
            this.data.length == 0 ? '' : this.pharData()
        }
    },
    mounted() {
        this.getDataIsBreak()
        this.getDataIsFlexible()
    },
}
</script>
<style scoped>
::v-deep .modal-header {
    border-bottom: none !important;
}
.headers-modal {
    padding-top: 32px;
    padding-bottom: 32px;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 18px;
    font-weight: bold;
    color: rgba(16, 16, 16, 1);
}
.btn-edit-submit {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:rgba(48, 107, 221, 1);
    color: white;
    font-size: 14px;
}
.btn-cancel {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-cancel:hover {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
</style>